import { memo } from 'react';

import { widgetRegistry } from '@/features/_shared/widget-registry';
import type { ToolResultContentPart } from '@/features/ai-chat/types/chat.types';

const WidgetMapper = ({ widgetData }: { widgetData: ToolResultContentPart }) => {
  /* oxlint-disable react-hooks-js/static-components -- registry returns a stable registered component, not a new instance */
  const Widget = widgetRegistry.resolve<{ data: ToolResultContentPart }>(widgetData.display);
  if (Widget) return <Widget data={widgetData} />;
  /* oxlint-enable react-hooks-js/static-components */
  return null;
};

export default memo(WidgetMapper);
